module.exports = __webpack_public_path__ + "static/media/view cleanliness category.5132ff9c.svg";